<div mat-dialog-title>
  Selecteer locatie
</div>
<div mat-dialog-content>
  <p>Selecteer een punt op de kaart of start met typen in het zoekveld oder selecteer de locatie van de taak door op de kaart te klikken</p>
  <div class="osm-address-input">
    <mat-form-field>
      <mat-label>Zoeken op adres</mat-label>
      <input [formControl]="form.controls.address" [matAutocomplete]="auto" matInput>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="showSelectedResult" autoActiveFirstOption>
        <mat-option *ngFor="let option of searchSuggestions" [value]="option">{{ option.weergavenaam }}</mat-option>
      </mat-autocomplete>
      <button (click)="clear()" *ngIf="showClear" mat-icon-button matSuffix>
        <mat-icon>clear</mat-icon>
      </button>
      <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
    </mat-form-field>
    <mat-form-field>
      <mat-label>X</mat-label>
      <input [formControl]="form.controls.new_rd_lat" matInput readonly>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Y</mat-label>
      <input [formControl]="form.controls.new_rd_lng" matInput readonly>
    </mat-form-field>
  </div>
  <div (leafletMapReady)="leafletMapService.init($event)" [leafletOptions]="leafletMapService.mapOptions" (leafletClick)="onMapClick($event)" class="map" leaflet></div>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-raised-button>ANNULEREN</button>
  <button *ngIf="!disableSave" [mat-dialog-close]="form.value" color="primary" mat-raised-button>OPSLAAN</button>
</mat-dialog-actions>
